import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Input, Button, ButtonToolbar} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm} from '../../core/redux/form'
import extract from '../../core/extract'
import CheckboxToggle from '../../core/components/CheckboxToggle'
import config from '../../config'
import {SUBSCRIBE_PROVIDER_COMPANY_TO_DIRECTORY_FOR_INTERVENTION_PERIOD_CMD_UPDATED, sendSubscribeProviderCompanyToDirectoryForInterventionPeriodCmd, updateSubscribeProviderCompanyToDirectoryForInterventionPeriodCmd, sendCancelServiceChargeForInterventionPeriodCmd, loadProvider} from '../actions'
import {FOR_WHATS, SubscribeProviderCompanyToDirectoryForInterventionPeriodCmd} from '../models'
import i18n from '../i18n'
import style from './SubscribeProviderCompanyToDirectoryForInterventionPeriodForm.less'

function defineCmdUpdate(interventionPeriod) {
    return {
        subscriptions: interventionPeriod.subscriptions
    }
}

class SubscribeProviderCompanyToDirectoryForInterventionPeriodForm extends Component {
    static propTypes = {
        activity: PropTypes.object.isRequired,
        interventionPeriod: PropTypes.object.isRequired,
        onSubmit: PropTypes.func.isRequired
    }

    componentWillMount() {
        const {dispatch, interventionPeriod} = this.props

        const update = defineCmdUpdate(interventionPeriod)
        dispatch(updateSubscribeProviderCompanyToDirectoryForInterventionPeriodCmd(update))
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.interventionPeriod != this.props.interventionPeriod) {
            const {dispatch, interventionPeriod} = nextProps

            const update = defineCmdUpdate(interventionPeriod)
            dispatch(updateSubscribeProviderCompanyToDirectoryForInterventionPeriodCmd(update))
        }
    }

    _sendCmd() {
        const {dispatch, activity, interventionPeriod, onSubmit} = this.props

        return dispatch(sendSubscribeProviderCompanyToDirectoryForInterventionPeriodCmd(activity.uid, interventionPeriod.uid)).then(() => {
            return dispatch(loadProvider())
        }).then(() => {
            onSubmit()
        })
    }

    render() {
        const {dispatch, form, cmd, activity, interventionPeriod, ...others} = this.props

        const subscriptionsField = (field, who) => {
            const subscriptions = field.value
            const index = subscriptions && subscriptions.findIndex((s) => s.forWho == who)
            const value = index >= 0 && subscriptions[index].forWhat || []

            function onChange(value) {
                var nextSubscriptions = subscriptions && [...subscriptions] || []

                if (value && value.length > 0) {
                    const nextSubscription = {
                        forWho: who,
                        forWhat: value
                    }

                    if (index >= 0) {
                        nextSubscriptions[index] = nextSubscription
                    } else {
                        nextSubscriptions.push(nextSubscription)
                    }
                } else {
                    if (index >= 0) {
                        nextSubscriptions.splice(index, 1)
                    }
                }
                field.onChange(nextSubscriptions)
            }

            return {...field, value, onChange}
        }

        return (
            <div className={style.default}>
                <Row>
                    <Col sm={6}>
                        <div className={style.section}>
                            <h5>{i18n.forWhoEnum.individuals}</h5>
                            <CheckboxToggle
                                {...subscriptionsField(form.subscriptions(), 'Individuals')}>
                                {FOR_WHATS.map((what, index) => (
                                    <Input
                                        key={index}
                                        type='checkbox'
                                        label={extract(i18n.forWhatEnum, what)}
                                        value={what} />
                                ))}
                            </CheckboxToggle>
                        </div>
                    </Col>
                    <Col sm={6}>
                        <div className={style.section}>
                            <h5>{i18n.forWhoEnum.professionals}</h5>
                            <CheckboxToggle
                                {...subscriptionsField(form.subscriptions(), 'Professionals')}>
                                {FOR_WHATS.map((what, index) => (
                                    <Input
                                        key={index}
                                        type='checkbox'
                                        label={extract(i18n.forWhatEnum, what)}
                                        value={what} />
                                ))}
                            </CheckboxToggle>
                        </div>
                    </Col>
                </Row>
                <ButtonToolbar>
                    <Button
                        bsStyle='primary'
                        bsSize='large'
                        className={cx({disabled: !form.isValid()})}
                        onClick={() => form.validate() && this._sendCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                        {i18n.validate}
                    </Button>
                </ButtonToolbar>
            </div>
        )
    }
}

SubscribeProviderCompanyToDirectoryForInterventionPeriodForm = connectForm({
    target: 'cmd',
    schema: SubscribeProviderCompanyToDirectoryForInterventionPeriodCmd.schema,
    action: SUBSCRIBE_PROVIDER_COMPANY_TO_DIRECTORY_FOR_INTERVENTION_PERIOD_CMD_UPDATED
})(SubscribeProviderCompanyToDirectoryForInterventionPeriodForm)

SubscribeProviderCompanyToDirectoryForInterventionPeriodForm = connect((state) => ({
    cmd: state.provider.subscribeProviderCompanyToDirectoryForInterventionPeriodCmd,
}))(SubscribeProviderCompanyToDirectoryForInterventionPeriodForm)

export default SubscribeProviderCompanyToDirectoryForInterventionPeriodForm


// WEBPACK FOOTER //
// ./lib/provider/components/SubscribeProviderCompanyToDirectoryForInterventionPeriodForm.js